<template>
  <div class="standard-resource-service">
    <div class="header-box">
      <span class="st-title">{{ title }}</span>
      <div class="tab-header-wrap">
        <div class="tab-item"
             v-for="(item, index) in tabList"
             :key="index"
             :class="{ active: activeTab === item.key }"
             @click="handleTabChange(item.key)"
        >
          {{ item.label }}
          <!-- 底部蓝色下划线 -->
          <span v-if="activeTab === item.key" class="tab-line"></span>
        </div>
      </div>
    </div>
    <div class="content-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandardResourceService',
  props: {
    // 当前激活tab标识
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标准资源服务'
    },
    tabList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    activeTab() {
      return this.value
    }
  },
  methods: {
    handleTabChange(key) {
      // 向父组件派发切换事件
      this.$emit('input', key)
      this.$emit('tab-change', key)
    }
  }
}
</script>

<style scoped>
.standard-resource-service {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  box-sizing: border-box;
  padding: 16px 24px;
}

.header-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  align-items: center;
}

.st-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.tab-header-wrap {
  margin-left: 12px;
  display: flex;
  align-items: center;
  width: fit-content;
  background: white;
  border-bottom: 1px solid #e9e9e9;
  box-sizing: border-box;
  padding-left: 48px;
}

.tab-item {
  position: relative;
  padding: 14px 20px;
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  transition: color 0.2s;
}

.tab-item:hover {
  color: #409eff;
}

.tab-item.active {
  color: #409eff;
  font-weight: 500;
}

.tab-line {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #409eff;
  display: block;
}

.content-box {
  flex: 1;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}
</style>